import React from 'react'
import styled from 'styled-components'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { greys } from 'assets/themes/theme-default'

const StyledSVG = styled(SVG)`
  width: 40%;
  height: 40%;
  fill: ${greys.light4};
`

const NoImage = styled.div`
  &&& {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${greys.dark3};
  }
`
export default () => (
  <NoImage data-test="component-image-placeholder">
    <StyledSVG svg={svg.image_placeholder} data-test="image-placeholder-svg" />
  </NoImage>
)
